// 表格导出：生成带 UTF-8 BOM 的 CSV（Excel 双击直接打开，中文不乱码），不引入表格库依赖

// CSV 单元格转义：含逗号/引号/换行时用双引号包裹，内部引号翻倍
function escapeCell(value) {
  if (value == null) return '';
  const s = String(value);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// rows：对象数组；columns：[{ title, value: (row) => 单元格值 }]
// filename 不含扩展名，导出时自动追加日期与 .csv
export function exportCsv({ filename, columns, rows }) {
  const header = columns.map((c) => escapeCell(c.title)).join(',');
  const body = rows.map((r) => columns.map((c) => escapeCell(c.value(r))).join(',')).join('\r\n');
  // BOM 让 Excel 以 UTF-8 解析
  const blob = new Blob(['﻿' + header + '\r\n' + body], {
    type: 'text/csv;charset=utf-8;'
  });

  const stamp = new Date()
    .toLocaleString('sv-SE')
    .replace(/[-: ]/g, '')
    .slice(0, 14);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}_${stamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
